import React from "react"

function createMarkup(text) {
  return { __html: text }
}

const Paragraph = ({ text }) => (
  <div className="paragraph" dangerouslySetInnerHTML={createMarkup(text)}></div>
)

export default Paragraph
